document.addEventListener("DOMContentLoaded", () => {
  const areaInput = document.querySelector("#area");
  const areaUnit = document.querySelector("#area_unit");

  const coverageInput = document.querySelector("#pergallon");
  const coverageUnit = document.querySelector("#coverage_unit");

  const pricePerGallonInput = document.querySelector("#price_per_gallon");

  const gallonsText = document.querySelector("#total_gallons");
  const totalCostText = document.querySelector("#total_cost");

  const btnCalculate = document.querySelector(".calculate_btn");
  const btnClear = document.querySelector(".clear_btn");
  const btnDownload = document.querySelector(".download_btn");

  const resultBox = document.querySelector(".total_coverage");

  let lastCalculation = { gallons: 0, cost: 0, calculated: false };

  const convertToSqFt = (value, unit) => {
    if (!value || value <= 0) return 0;
    if (unit === "sqm") return value * 10.7639;
    if (unit === "sqyd") return value * 9;
    return value;
  };

  const formatMoney = (amount) => {
    const num = Number(amount || 0);
    return `$${num.toFixed(2)}`;
  };

  const resetOutputs = () => {
    if (gallonsText) gallonsText.textContent = "0 gallons";
    if (totalCostText) totalCostText.textContent = "$0.00";
    lastCalculation = { gallons: 0, cost: 0, calculated: false };
  };

  const calculate = () => {
    const areaValue = parseFloat(areaInput?.value || 0);
    const coverageValue = parseFloat(coverageInput?.value || 0);
    const priceValue = parseFloat(pricePerGallonInput?.value || 0);

    const areaSqFt = convertToSqFt(areaValue, areaUnit?.value);
    const coverageSqFt = convertToSqFt(coverageValue, coverageUnit?.value);

    if (!areaSqFt || areaSqFt <= 0 || !coverageSqFt || coverageSqFt <= 0) {
      resetOutputs();
      return;
    }

    const gallonsRequired = Math.ceil(areaSqFt / coverageSqFt);

    let totalCost = 0;
    if (priceValue > 0) totalCost = gallonsRequired * priceValue;

    if (gallonsText) {
      gallonsText.textContent = `${gallonsRequired} gallon${gallonsRequired > 1 ? "s" : ""}`;
    }
    if (totalCostText) {
      totalCostText.textContent = formatMoney(totalCost);
    }

    lastCalculation = {
      gallons: gallonsRequired,
      cost: totalCost,
      calculated: true
    };
  };

  const clearAll = () => {
    if (areaInput) areaInput.value = "";
    if (coverageInput) coverageInput.value = "";
    if (pricePerGallonInput) pricePerGallonInput.value = "";

    if (areaUnit) areaUnit.value = "sqft";
    if (coverageUnit) coverageUnit.value = "sqft";

    resetOutputs();
  };

  const downloadResultAsImage = async () => {
    const priceValue = parseFloat(pricePerGallonInput?.value || 0);

    if (!lastCalculation.calculated || lastCalculation.gallons <= 0) return;
    if (!priceValue || priceValue <= 0) return;
    if (!resultBox) return;

    if (typeof domtoimage === "undefined") {
      console.warn("dom-to-image-more not found. Please include the library.");
      return;
    }

    try {
      const dataUrl = await domtoimage.toPng(resultBox, {
        quality: 1,
        bgcolor: "#ffffff",
        cacheBust: true
      });

      const link = document.createElement("a");
      link.download = "coverage-estimate.png";
      link.href = dataUrl;
      link.click();
    } catch (err) {
      console.error("Screenshot download failed:", err);
    }
  };

  btnCalculate?.addEventListener("click", (e) => {
    e.preventDefault();
    calculate();
  });

  btnClear?.addEventListener("click", (e) => {
    e.preventDefault();
    clearAll();
  });

  btnDownload?.addEventListener("click", (e) => {
    e.preventDefault();
    downloadResultAsImage();
  });

  resetOutputs();
});
